import _ from 'lodash';

import { list } from './tags';

function endpoints(builder) {
  return {
    getVettingExpensesCurrencyExchangeRate: builder.query({
      query: () => 'tefaf/tefafportal/vetter-expenses-currency-exchange-rate/latest',
      providesTags: list,
    }),
    createVettingExpensesCurrencyExchangeRate: builder.mutation({
      invalidatesTags: list,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/tefafportal/vetter-expenses-currency-exchange-rate/create');
        _.forEach(values.vetterExpensesCurrencyExchangeRate, ({
          from,
          to,
          rate,
        }, index) => {
          body.append(`fields[vetterExpensesCurrencyExchangeRate][${index}][from]`, from);
          body.append(`fields[vetterExpensesCurrencyExchangeRate][${index}][to]`, to);
          body.append(`fields[vetterExpensesCurrencyExchangeRate][${index}][rate]`, rate);
        });

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
